export const WINWINMAINPACKAGES = [
    {
        "Name": "Single Ticket for $10",
        "PackageName": "Single Ticket",
        "Cost": 10
    },
    {
        "Name": "Set of 5 Tickets for $20",
        "PackageName": "Set of 5 Tickets",
        "Cost": 20
    },
    {
        "Name": "Set of 10 Tickets for $30",
        "PackageName": "Set of 10 Tickets",
        "Cost": 30
    },
    {
        "Name": "Set of 20 Tickets for $35",
        "PackageName": "Set of 20 Tickets",
        "Cost": 35
    },
    {
        "Name": "Set of 20 Tickets for $40",
        "PackageName": "Set of 20 Tickets",
        "Cost": 40
    },
]

export const WINWIN5050PACKAGES = [
    {
        "Name": "Single Ticket for $5",
        "PackageName": "Single Ticket",
        "Cost": 5
    },
    {
        "Name": "Set of 5 Tickets for $10",
        "PackageName": "Set of 5 Tickets",
        "Cost": 10
    },
    {
        "Name": "Set of 5 Tickets for $15",
        "PackageName": "Set of 5 Tickets",
        "Cost": 15
    },
    {
        "Name": "Set of 10 Tickets for $17.5",
        "PackageName": "Set of 10 Tickets",
        "Cost": 17.5
    },
    {
        "Name": "Set of 10 Tickets for $25",
        "PackageName": "Set of 10 Tickets",
        "Cost": 25
    },
    {
        "Name": "Set of 20 Tickets for $30",
        "PackageName": "Set of 20 Tickets",
        "Cost": 30
    },
    {
        "Name": "Set of 20 Tickets for $35",
        "PackageName": "Set of 20 Tickets",
        "Cost": 35
    }
]

export const DEDUCTIONSCHEDULE = [
    new Date("January 8, 2025"),
    new Date("January 22, 2025"),
    new Date("February 5, 2025"),
    new Date("February 19, 2025"),
    new Date("March 5, 2025"),
    new Date("March 19, 2025"),
    new Date("April 2, 2025"),
    new Date("April 16, 2025"),
    new Date("April 30, 2025"),
    new Date("May 14, 2025"),
    new Date("May 28, 2025"),
    new Date("June 11, 2025"),
    new Date("June 25, 2025"),
    new Date("July 9, 2025"),
    new Date("July 23, 2025"),
    new Date("August 6, 2025"),
    new Date("August 20, 2025"),
    new Date("September 3, 2025"),
    new Date("September 17, 2025"),
    new Date("October 1, 2025"),
    new Date("October 15, 2025"),
    new Date("October 29, 2025"),
    new Date("November 12, 2025"),
    new Date("November 26, 2025"),
    new Date("December 10, 2025"),
    new Date("December 24, 2025"),
]

export const DRAWDATESANDDEADLINES = [
    {
        "DrawDate": "February 13, 2025",
        "Deadline": "January 8, 2025"
    },
    {
        "DrawDate": "March 13, 2025",
        "Deadline": "February 5, 2025"
    },
    {
        "DrawDate": "April 10, 2025",
        "Deadline": "March 5, 2025"
    },
    {
        "DrawDate": "May 8, 2025",
        "Deadline": "April 16, 2025"
    },
    {
        "DrawDate": "June 12, 2025",
        "Deadline": "May 14, 2025"
    },
    {
        "DrawDate": "July 10, 2025",
        "Deadline": "June 11, 2025"
    },
    {
        "DrawDate": "August 14, 2025",
        "Deadline": "July 9, 2025"
    },
    {
        "DrawDate": "September 11, 2025",
        "Deadline": "August 6, 2025"
    },
    {
        "DrawDate": "October 9, 2025",
        "Deadline": "September 3, 2025"
    },
    {
        "DrawDate": "November 13, 2025",
        "Deadline": "October 15, 2025"
    },
    {
        "DrawDate": "December 11, 2025",
        "Deadline": "November 12, 2025"
    },
    {
        "DrawDate": "January 8, 2026",
        "Deadline": "December 10, 2025"
    }
]

export function nextDrawDate(today) {
    var futureDraws = DRAWDATESANDDEADLINES.filter(x=>new Date(x.Deadline) >= today);
    if (futureDraws.length > 0) 

    return futureDraws[0].DrawDate
}

export function nextDrawDateWhenEnrolled(today) {
    var futureDraws = DRAWDATESANDDEADLINES.filter(x=>new Date(x.DrawDate) >= today);
    if (futureDraws.length > 0) 

    return futureDraws[0].DrawDate
}

export function nextDeadlineDate(today) {
    var futureDraws = DRAWDATESANDDEADLINES.filter(x=>new Date(x.Deadline) >= today);
    if (futureDraws.length > 0) 

    return futureDraws[0].Deadline
}